var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasElectricalSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#EFE8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#EFE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9869 14.3856C20.968 14.3054 20.9295 14.2312 20.875 14.1695C20.8205 14.1078 20.7516 14.0605 20.6744 14.0318L17.0738 12.6812L17.99 8.09806C18.0108 7.99157 17.9963 7.88123 17.9489 7.78368C17.9014 7.68612 17.8235 7.60665 17.7269 7.55726C17.6303 7.50787 17.5202 7.49124 17.4134 7.50987C17.3065 7.52851 17.2086 7.5814 17.1344 7.66056L10.1344 15.1606C10.0775 15.2205 10.0364 15.2935 10.0147 15.3732C9.99296 15.4529 9.9913 15.5367 10.0099 15.6172C10.0284 15.6977 10.0667 15.7723 10.1211 15.8344C10.1756 15.8965 10.2445 15.9441 10.3219 15.9731L13.9238 17.3237L13.01 21.9018C12.9893 22.0083 13.0037 22.1186 13.0512 22.2162C13.0987 22.3138 13.1766 22.3932 13.2732 22.4426C13.3698 22.492 13.4798 22.5086 13.5867 22.49C13.6935 22.4714 13.7915 22.4185 13.8656 22.3393L20.8656 14.8393C20.9215 14.7794 20.9617 14.7067 20.9829 14.6276C21.004 14.5484 21.0054 14.4653 20.9869 14.3856ZM14.3356 20.3749L14.99 17.1012C15.0134 16.9851 14.9949 16.8644 14.9377 16.7607C14.8804 16.657 14.7882 16.577 14.6775 16.5349L11.375 15.2943L16.6638 9.62806L16.01 12.9018C15.9866 13.0179 16.0052 13.1386 16.0624 13.2423C16.1196 13.346 16.2118 13.426 16.3225 13.4681L19.6225 14.7056L14.3356 20.3749Z",
    fill: "#7F43FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasElectricalSafety);
export default __webpack_public_path__ + "static/media/GasElectricalSafety.cc79fed545810cd598fdfa8be94ca3c8.svg";
export { ForwardRef as ReactComponent };